import { Filter } from "react-feather";
import { Link } from "react-router-dom";
import { Href } from "../../../../constants";
import { routes } from "../../../../routers/routes";
import { TopLinkProps } from "../../../../types/Ecommerce";

// A navigation component with a toggle button and a "Add Product" button.
const TopLinks: React.FC<TopLinkProps> = ({ buttonName, setShowList, showList }) => {

  return (
    <div>
      <div className="light-box" onClick={() => setShowList(!showList)}>
        <Link to={Href}>
          <Filter className={`${showList ? "hide" : "show"}`} />
          <i className={`icon-close ${showList ? "show" : "hide"}`} />
        </Link>
      </div>
      <Link className="btn btn-primary" to={routes.ECommerce.AddProduct}>
        <i className="fa fa-plus" />
        {buttonName}
      </Link>
    </div>
  );
};
export default TopLinks;